import React from 'react';
import { useAuth } from '../../contexts/Auth/authContext';
import { useI18n } from '../../contexts/I18nContext';
import config from '../../config/env';
import { environmentFromOAuthClientId } from '../../utils/clientGroups';

export const AccessDisabledScreen: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const env = environmentFromOAuthClientId(config.oauth.clientId);

  return (
    <div className="access-disabled-screen" data-testid="access-disabled-screen">
      <div className="access-disabled-card">
        <span className="access-disabled-icon" aria-hidden="true">🔒</span>
        <h1>{t('errors.accessDisabledTitle')}</h1>
        <p className="access-disabled-lead">{t('errors.accessDisabledBody', { env })}</p>
        <dl className="access-disabled-meta">
          <div>
            <dt>{t('users.username')}</dt>
            <dd>{user?.preferredUsername || user?.name || '-'}</dd>
          </div>
          <div>
            <dt>{t('clients.users.envHint')}</dt>
            <dd>{env}</dd>
          </div>
        </dl>
        <p className="access-disabled-help">{t('errors.accessDisabledHelp')}</p>
        <button type="button" className="access-disabled-logout" onClick={logout}>
          {t('nav.logout')}
        </button>
      </div>
    </div>
  );
};
